module.exports = __webpack_public_path__ + "static/blog_01-960x550-2a37dafa3209a0cf04fa16ab42a4619a.jpg";